import './CoralPdpWhatsIncluded.scss'
import '../../../coral-library/css/_layout.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { mapCoralWebPdpWhatSIncluded } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { CheckIcon } from '../../../coral-library/icons/Check.icon'

type CoralPdpWhatsIncludedProps = ReturnType<typeof mapCoralWebPdpWhatSIncluded>

export const CoralPdpWhatsIncluded: FC<CoralPdpWhatsIncludedProps> = ({
  header,
  content,
  cards,
}) => {
  return (
    <div className={'container-coral-spot'}>
      <div className={'pdp-whats-included'}>
        <div className={'pdp-whats-included__top-section-wrapper'}>
          <h2 className={'pdp-whats-included__header'}>{header}</h2>
          <div className={'pdp-whats-included__content'}>{content}</div>
        </div>
        <div className={'pdp-whats-included__cards'}>
          {cards.map((card, index) => (
            <div className={'pdp-whats-included__card'} key={index}>
              <Asset
                className={'pdp-whats-included__split-asset'}
                lazyLoading={true}
                objectFit={'cover'}
                srcSetWidths={[400, 600, 800, 1200, 1600]}
                thumbnail={card.asset?.thumbnail}
                video={card.asset?.video}
              />
              <div className={'pdp-whats-included__card-bottom-wrapper'}>
                <div className={'pdp-whats-included__card-header'}>{card.header}</div>
                <CardContent card={card} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const CardContent: FC<{ card: CoralPdpWhatsIncludedProps['cards'][0] }> = ({ card }) => {
  return (
    <div className={'pdp-whats-included__card-list'}>
      {card.list_fragments.map((fragment, index) => (
        <div className={'pdp-whats-included__fragment'} key={index}>
          {fragment.subheader ? (
            <div
              className={`pdp-whats-included__fragment-subheader ${
                index !== 0 ? 'm--marginTop' : ''
              }`}
            >
              {fragment.subheader}
            </div>
          ) : null}
          {fragment.bullet_point_label ? (
            <div className={'pdp-whats-included__fragment-point-wrapper'}>
              <CheckIcon className={'pdp-whats-included__fragment-point-icon'} />
              <div className={'pdp-whats-included__fragment-point-label'}>
                {fragment.bullet_point_label}
              </div>
            </div>
          ) : null}
          {fragment.markdown ? (
            <Markdown className={'pdp-whats-included__description'} markdown={fragment.markdown} />
          ) : null}
        </div>
      ))}
    </div>
  )
}
